/* unplugin-vue-components disabled */import { render } from "./NoAuthView.vue?vue&type=template&id=3cc5c0c1"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__